/**
 * Neutral app header (no logo image, no ENKA references).
 * Renders the project title + optional subtitle + optional right-slot element.
 */
export function AppHeader({ subtitle, compact = false, rightSlot = null }) {
  return (
    <header
      data-testid="app-header"
      className="enka-header-bar w-full"
    >
      <div className={`mx-auto flex max-w-5xl items-center gap-3 px-5 ${compact ? "py-3" : "py-5"}`}>
        <div className="leading-tight min-w-0 flex-1">
          <div
            className={`font-display ${compact ? "text-base" : "text-base sm:text-lg"} tracking-wide truncate`}
            data-testid="app-title"
          >
            IQ3B9 IT Support System
          </div>
          {subtitle ? (
            <div className="text-xs text-white/75 mt-0.5 truncate">{subtitle}</div>
          ) : null}
        </div>
        {rightSlot ? <div className="shrink-0">{rightSlot}</div> : null}
      </div>
    </header>
  );
}

// Backward-compatible alias so existing imports keep working during transition.
export { AppHeader as EnkaHeader };
